// extracted by mini-css-extract-plugin
module.exports = {"colors__item":"styles_colors__item__ojEcZ"};